exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ai-header__icon svg g,.ai-header__icon svg path{fill:currentColor}\n", ""]);

